import React, { useRef, useState } from "react";
import { Button } from "components/buttons";
import { ShowHide } from "components/layout";
import { FormHelperText } from "components/form-fields";
import { DateToLocal } from "components/dates";
import SignatureCanvas from "react-signature-canvas";
import PropTypes from "prop-types";
import classNames from "classnames";
import 'components/form-fields/FormFields.css';

export function FormCanvas({
    isLoading = false,
    penColour = "grey",
    backgroundColour = "rgba(0,0,0,0)",
    headingText = "",
    helperText = <></>,
    onChange = () => { },
    showDate = false,
    width = null,
    height = null,
    showOverlay = false,
    overlayLabel = "",
    format = "image/jpeg",
    readOnly = false,
    signedDate = null,
    imageSource = null
}) {
    const canvas = useRef(null);
    const [dateOfSignature, setDateOfSignature] = useState(null);

    function getValue() {
        let value = canvas.current.toDataURL(format);
        onChange(value);
        setDateOfSignature(new Date());
    }

    function clearCanvas() {
        canvas.current.clear();
        onChange("");
        setDateOfSignature(null);
    }

    return (
        <div className="form-field">
            <ShowHide
                evaluator={headingText != null}
                show={
                    <h3 className={classNames({ "bp6-skeleton": isLoading })}>
                        {headingText}
                    </h3>
                }
            />
            <FormHelperText loading={isLoading}>{helperText}</FormHelperText>
            <div
                className={classNames("canvas-container", { "bp6-skeleton": isLoading })}
                style={{
                    width: width || "30%",
                    height: height || "200px",
                }}
            >
                <ShowHide
                    evaluator={!readOnly}
                    show={
                        <div className="clear-button-container">
                            <Button
                                minimal
                                iconOnly
                                icon="cross"
                                onClick={clearCanvas}
                            />
                        </div>
                    }
                />
                <div className="overlay" style={{ display: showOverlay ? 'grid' : 'none' }}>
                    <p>{overlayLabel}</p>
                </div>
                <ShowHide
                    evaluator={readOnly}
                    show={
                        <img
                            className="form-field-signature-canvas"
                            src={imageSource}
                            alt="Signature"
                        />
                    }
                    hide={
                        <SignatureCanvas
                            minWidth={1}
                            maxWidth={1}
                            penColor={penColour}
                            backgroundColor={backgroundColour}
                            ref={canvas}
                            canvasProps={{
                                className: "form-field-signature-canvas",
                            }}
                            onEnd={getValue}
                        />
                    }
                />
            </div>
            <ShowHide
                evaluator={showDate}
                show={
                    <p className={classNames("spacer-top-small", { "bp6-skeleton": isLoading })}>
                        Date of Signature: <DateToLocal>{signedDate ?? dateOfSignature}</DateToLocal>
                    </p>
                }
            />
        </div>
    );
}

FormCanvas.propTypes = {
    isLoading: PropTypes.bool,
    height: PropTypes.string,
    width: PropTypes.string,
    penColour: PropTypes.string,
    backgroundColour: PropTypes.string,
    headingText: PropTypes.string,
    helperText: PropTypes.node,
    onChange: PropTypes.func,
    showDate: PropTypes.bool,
    showOverlay: PropTypes.bool,
    overlayLabel: PropTypes.string,
    format: PropTypes.string,
    readOnly: PropTypes.bool,
    signedDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    imageSource: PropTypes.string
};
